/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * The init translation constants for Personal Account
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Dmitriy Kvon
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.0
 */
import { IPagePersonalAccountTranslation } from '../../types';

const initTranslationPagePersonalAccount: IPagePersonalAccountTranslation = {
    table: {
        accountBisId: '',
        assistantCampaignsCount: {
            header: '',
        },
        id: '',
        loyaltyStatus: '',
        serviceType: '',
        number: {
            header: '',
            placeholder: '',
        },
        name: {
            header: '',
            placeholder: '',
        },
        balance: {
            header: '',
        },
        contract: {
            header: '',
            placeholder: '',
        },
        coordinatorCampaignsCount: {
            header: '',
        },
        kpp: {
            header: '',
            placeholder: '',
        },
        persDataStatusName: {
            header: '',
        },
        persDataLockDate: {
            header: '',
        },
        regionName: {
            header: '',
        },
        subdivisionKpp: {
            header: '',
        },
        subdivisionName: {
            header: '',
        },
        subsCount: {
            header: '',
        },
        unpaidBillsCount: {
            header: '',
        },
    },
    tableFooter: {
        basketTitle: '',
        mobileCashFileSuccessfulText: '',
        cancel: '',
    },
    title: {
        dropFilters: '',
        exportBtn: '',
        filterSetting: '',
        header: '',
        fastActionRadioButton: '',
        fastAdvanceInvoiceTitle: '',
        fastAdvanceInvoiceSubtitle: '',
        fastPromisedPaymentTitle: '',
        fastPromisedPaymentSubtitle: '',
        wizardFastBillsDocSubtitle: '',
        wizardFastReportDocSubstitle: '',
        tableSetting: {
            applyBtn: '',
            closeBtn: '',
            footnote: '',
            subTitle: '',
            title: '',
            titleBtn: '',
        },
    },
};

export default initTranslationPagePersonalAccount;
